var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { PrismicService } from '../prismic/prismic.service';
import { NewsService } from '../news/news.service';
import { ZevensterService } from '../zevenster/zevenster.service';
import { OccurenceService } from '../occurence/occurence.service';
import { ZevensterAjaxService } from '../zevenster-ajax/zevenster-ajax.service';
import * as Masonry from 'masonry-layout';
import zevensterAreaConstants from '../zevenster-area/zevenster-area-constants';
var PanelGridComponent = /** @class */ (function () {
    function PanelGridComponent(prismicService, newsService, ZevensterService, occurenceService, elementRef, zevensterAjaxService) {
        var _this = this;
        this.prismicService = prismicService;
        this.newsService = newsService;
        this.ZevensterService = ZevensterService;
        this.occurenceService = occurenceService;
        this.elementRef = elementRef;
        this.zevensterAjaxService = zevensterAjaxService;
        this.panels = [];
        this.limit = 3;
        this.numberOfPanels = 0;
        this.numberOfPanelsLoaded = 0;
        this.savedM2Count = 0;
        this.totalM2Count = zevensterAreaConstants.AREA;
        zevensterAjaxService.fetchPurchasedAreaIds().then(function (areaIds) {
            _this.savedM2Count = areaIds.size;
        });
    }
    PanelGridComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var api, loadNewsPromise, loadOccurencesPromise, loadZevensterPromise, allPromises, _i, allPromises_1, promise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prismicService.api()];
                    case 1:
                        api = _a.sent();
                        loadNewsPromise = this.loadNews(api);
                        loadOccurencesPromise = this.loadOccurences(api);
                        loadZevensterPromise = this.loadZevenster(api);
                        allPromises = [loadNewsPromise, loadOccurencesPromise, loadZevensterPromise];
                        for (_i = 0, allPromises_1 = allPromises; _i < allPromises_1.length; _i++) {
                            promise = allPromises_1[_i];
                            promise.then(function (panels) {
                                _this.panels = _this.panels.concat(panels);
                                _this.panels = _this.panels.sort(function (a, b) {
                                    if (a.type === 'saveTheForest')
                                        return -1;
                                    if (b.type === 'saveTheForest')
                                        return 1;
                                    if (a.options && a.options.pinned)
                                        return -1;
                                    if (b.options && b.options.pinned)
                                        return 1;
                                    return a.date > b.date ? -1 : 1;
                                });
                            });
                        }
                        this.allPromise = Promise.all(allPromises);
                        this.allPromise.then(function (panelsMatrix) {
                            for (var _i = 0, panelsMatrix_1 = panelsMatrix; _i < panelsMatrix_1.length; _i++) {
                                var panels = panelsMatrix_1[_i];
                                _this.numberOfPanels += panels.length;
                            }
                        });
                        this.allPromise.then(function () {
                            _this.setupStaticPanels();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PanelGridComponent.prototype.setupStaticPanels = function () {
        var nPinnedPanels = this.panels.filter(function (p) { return p.options.pinned; }).length;
        var welcomePanel = {
            type: 'welcome',
            date: new Date(),
            options: { size: 'normal', pinned: false }
        };
        this.panels.splice(1, 0, welcomePanel); // this.panels.splice(nPinnedPanels, 0, welcomePanel);
        this.numberOfPanels += 1;
    };
    PanelGridComponent.prototype.loadOccurences = function (api) {
        return __awaiter(this, void 0, void 0, function () {
            var unorderedPanels, occurences, _i, occurences_1, occurence, panel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        unorderedPanels = [];
                        return [4 /*yield*/, this.occurenceService.fetchAll()];
                    case 1:
                        occurences = _a.sent();
                        for (_i = 0, occurences_1 = occurences; _i < occurences_1.length; _i++) {
                            occurence = occurences_1[_i];
                            panel = {
                                type: 'occurence',
                                date: occurence.date,
                                occurence: occurence,
                                options: {
                                    size: 'small',
                                    pinned: false
                                }
                            };
                            unorderedPanels.push(panel);
                        }
                        return [2 /*return*/, unorderedPanels];
                }
            });
        });
    };
    PanelGridComponent.prototype.loadNews = function (api) {
        return __awaiter(this, void 0, void 0, function () {
            var allItems, newsItems, unorderedPanels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.newsService.getItems()];
                    case 1:
                        allItems = _a.sent();
                        newsItems = allItems.slice(0, this.limit);
                        unorderedPanels = newsItems.map(function (newsItem) {
                            var panel = {
                                type: 'newsItem',
                                newsItem: newsItem,
                                date: newsItem.date,
                                options: newsItem.panelOptions
                            };
                            return panel;
                        });
                        return [2 /*return*/, unorderedPanels];
                }
            });
        });
    };
    PanelGridComponent.prototype.loadZevenster = function (api) {
        return __awaiter(this, void 0, void 0, function () {
            var stf, panel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ZevensterService.getZevenster()];
                    case 1:
                        stf = _a.sent();
                        panel = {
                            type: 'saveTheForest',
                            saveTheForest: stf,
                            date: new Date(),
                            options: {
                                size: 'big',
                                pinned: true
                            }
                        };
                        return [2 /*return*/, [panel]];
                }
            });
        });
    };
    PanelGridComponent.prototype.setupMasonry = function () {
        var _this = this;
        var msnry = new Masonry(this.elementRef.nativeElement, {
            itemSelector: '.panel-container',
            columnWidth: 300,
            gutter: 16,
            fitWidth: true
        });
        msnry.on('layoutComplete', function () {
            _this.elementRef.nativeElement.classList.add('laidout');
        });
        window.setTimeout(function () { return msnry.layout(); }, 100);
    };
    PanelGridComponent.prototype.setPanelLoaded = function (panel) {
        this.numberOfPanelsLoaded += 1;
        if (this.numberOfPanelsLoaded === this.numberOfPanels) {
            this.setupMasonry();
        }
    };
    // TODO: replace this method with prismic lookup
    PanelGridComponent.prototype.unkebab = function (uid) {
        return uid.split('-').map(function (item) {
            return item.charAt(0).toUpperCase() + item.substring(1);
        }).join(' ');
    };
    return PanelGridComponent;
}());
export { PanelGridComponent };
//# sourceMappingURL=panel-grid.component.js.map